import {createSelector} from 'reselect';

const selectState = (state) => state.advancedDiagnostic;

const selectDiagnosticFlowDataResult = createSelector(selectState, (state) => state.diagnosticFlowDataResult);

export {selectDiagnosticFlowDataResult};
